import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "color-field" }

import { ref, computed, watch } from 'vue'
import { isEqual } from 'lodash'


export default {
  __name: 'fieldColor',
  props: {
  colorDefault: {
    type: Object,
    required: true
  }
},
  emits: ['color-change'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const showPicker = ref(false)
const colors = ref(props.colorDefault.hex)

const displayValue = computed(() => {
  return colors.value
})

watch(
  () => props.colorDefault,
  (curr, prev) => {
    if (!isEqual(curr, prev)) {
      colors.value = curr.hex
    }
  },
  { deep: true }
)

const updateColor = (color) => {
  colors.value = color
  emit('color-change', {
    hex: color,
    a: 1
  })
}

return (_ctx, _cache) => {
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_color_picker = _resolveComponent("v-color-picker")
  const _component_v_menu = _resolveComponent("v-menu")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_text_field, {
      "model-value": displayValue.value,
      onClick: _cache[1] || (_cache[1] = $event => (showPicker.value = true)),
      variant: "outlined",
      "hide-details": "",
      readonly: "",
      class: "mb-2"
    }, {
      "append-inner": _withCtx(() => [
        _createElementVNode("div", {
          class: "color-preview",
          style: _normalizeStyle({ 'background-color': displayValue.value }),
          onClick: _cache[0] || (_cache[0] = $event => (showPicker.value = true))
        }, null, 4)
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_v_menu, {
      modelValue: showPicker.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((showPicker).value = $event)),
      "close-on-content-click": false,
      location: "bottom",
      attach: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_color_picker, {
          "model-value": colors.value,
          "onUpdate:modelValue": updateColor,
          mode: "hexa",
          elevation: "2"
        }, null, 8, ["model-value"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

}